import { FeatureNameEnum } from '../features';
import { NavigationItemInterface } from '../interfaces';
import { RoutesEnum } from '../routes';

export const projectsNavigationItem: Readonly<NavigationItemInterface> = {
  name: FeatureNameEnum.Projects,
  icon: 'work',
  route: `/${RoutesEnum.Projects}`,
};
